"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Value = exports.Label = exports.Description = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _index = require("../../../LexusTypography/index");
var _breakpoints = _interopRequireDefault(require("../../../breakpoints"));
var SpecHighlightV1Styles = _interopRequireWildcard(require("../V1/index.styled"));
const Container = exports.Container = (0, _styledComponents.default)(SpecHighlightV1Styles.Container)`
  flex-direction: row;
  justify-content: start;
  align-items: center;
  text-align: left;
  gap: 12px;
  ${(0, _breakpoints.default)("tablet", "up")} {
    max-width: none;
  }
`;
const Label = exports.Label = (0, _styledComponents.default)(SpecHighlightV1Styles.Label)`
  text-align: left;
  color: #000;
  ${(0, _index.nobel)({
  sizing: "subheading16"
})}
  line-height: 19px;
`;
const Value = exports.Value = (0, _styledComponents.default)(SpecHighlightV1Styles.Value)`
    text-align: left;
    ${(0, _index.nobel)({
  sizing: "heading32",
  weight: "light"
})}
`;
const Description = exports.Description = _styledComponents.default.span`
  text-align: left;
  min-height: 20px;
  ${(0, _index.nobel)({
  sizing: "subheading14"
})}
`;
const Wrapper = exports.Wrapper = _styledComponents.default.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
`;